import React from "react";

// Helper to underline and bold only the <u>...</u> part in the question string
function renderQuestionWithUnderline(question) {
  if (typeof question !== 'string') {
    return { __html: '' };
  }
  return {
    __html: question.replace(
      /（\s*）|\(\s*\)/,
      '<span style="font-weight:bold;">（　）</span>'
    )
  };
}

const backgroundColors = ['#e3f2fd', '#f1f8e9', '#fff8e1', '#fce4ec'];

const N3Dokai1 = ({
  questions,
  selectedAnswers,
  showResult,
  handleAnswerChange,
}) => {
  if (!questions) return null;

  return (
    <div>
      <div style={{ fontSize: "1.2rem", marginBottom: "0.5rem", fontWeight: 'bold' }}>
        読解<br />
        問題４ つぎの(１)から(４)の文章を読んで、質問に答えなさい。答は、１・２・３・４から最もよいものを一つえらびなさい。
      </div>

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {questions.map((item, idx) => (
          <li
            key={item.id}
            style={{
              marginBottom: '2.5rem',
              width: '100%',
              background: backgroundColors[idx % backgroundColors.length],
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(25,118,210,0.07)',
              padding: '1.2rem'
            }}
          >
            {item.content && (
              <div
                style={{
                  marginBottom: '1rem',
                  background: '#fff',
                  padding: '1rem',
                  borderRadius: '8px',
                  fontSize: '1.2rem',
                  lineHeight: 1.6
                }}
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            )}

            <div style={{ marginBottom: '1rem', fontSize: '1.2rem', fontWeight: 500 }}>
              <span style={{ marginRight: 12 }}>{idx + 23}.</span>
              <span dangerouslySetInnerHTML={renderQuestionWithUnderline(item.question)} />
            </div>

            {item.answers && item.answers.length === 4 && (
              <div style={{ width: '100%' }}>
                {[0, 2].map(rowStart => (
                  <div
                    key={rowStart}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '1.5rem',
                      marginBottom: '0.7rem',
                    }}
                  >
                    {[0, 1].map(col => {
                      const ansIdx = rowStart + col;
                      const ans = item.answers[ansIdx];
                      const isSelected = selectedAnswers[item.id] === ansIdx;

                      let color;
                      if (showResult) {
                        if (ansIdx === item.correct) {
                          color = 'green';
                        } else if (isSelected) {
                          color = 'red';
                        }
                      }

                      return (
                        <label
                          key={ansIdx}
                          style={{
                            flex: 1,
                            minWidth: '40%',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '0.8rem 1rem',
                            borderRadius: '6px',
                            border: '1px solid #e0e0e0',
                            background: '#fff',
                            cursor: showResult ? 'default' : 'pointer',
                            fontSize: '1.1rem',
                            fontWeight: isSelected ? 700 : 500,
                            textDecoration: isSelected ? 'underline' : 'none',
                            color: color,
                            transition: 'all 0.2s',
                            wordBreak: 'break-word'
                          }}
                        >
                          <input
                            type="radio"
                            name={`question-${item.id}`}
                            value={ansIdx}
                            checked={isSelected}
                            onChange={() => handleAnswerChange(item.id, ansIdx)}
                            disabled={showResult}
                            style={{
                              marginRight: 14,
                              accentColor: "#1976d2",
                              width: 22,
                              height: 22
                            }}
                          />
                          {ans}
                          {showResult && ansIdx === item.correct && (
                            <span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '1.2rem' }}>✓</span>
                          )}
                          {showResult && isSelected && ansIdx !== item.correct && (
                            <span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '1.2rem', color: 'red' }}>✗</span>
                          )}
                        </label>
                      );
                    })}
                  </div>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default N3Dokai1;
